import * as Mod1 from "./discourse/admin-community-navigation-plugin-route-map";
import * as Mod2 from "./discourse/community-navigation-route-map";
import * as Mod3 from "./discourse/components/community-game-order-handle";
import * as Mod4 from "./discourse/components/community-navigation-header-menu";
import * as Mod5 from "./discourse/components/community-secondary-navigation-item";
import * as Mod6 from "./discourse/components/community-secondary-navigation";
import * as Mod7 from "./discourse/components/community-topic-aggregation";
import * as Mod8 from "./discourse/controllers/admin-plugins/show/community-navigation-structure";
import * as Mod9 from "./discourse/initializers/community-navigation-admin-plugin-configuration-nav";
import * as Mod10 from "./discourse/initializers/community-navigation";
import * as Mod11 from "./discourse/initializers/disable-indented-code-block";
import * as Mod12 from "./discourse/lib/community-navigation-selection";
import * as Mod13 from "./discourse/lib/disable-indented-code-block";
import * as Mod14 from "./discourse/lib/disable-indented-code-rich-editor";
import * as Mod15 from "./discourse/pre-initializers/community-navigation-chat-default";
import * as Mod16 from "./discourse/routes/admin-plugins/show/community-navigation-structure";
import * as Mod17 from "./discourse/routes/community-creator-resources";
import * as Mod18 from "./discourse/routes/community-game";
import * as Mod19 from "./discourse/routes/community-media-feedback";
import * as Mod20 from "./discourse/routes/community-media";
import * as Mod21 from "./discourse/routes/creator-community";
import * as Mod22 from "./discourse/routes/mod-community";
import * as Mod23 from "./discourse/services/community-game-order";
import * as Mod24 from "./discourse/services/community-navigation-notices";
import * as Mod25 from "./discourse/services/community-navigation";
import * as Mod26 from "./discourse/services/erbox-toasts";
import * as Mod27 from "./discourse/templates/community-creator-resources";
import * as Mod28 from "./discourse/templates/community-game";
import * as Mod29 from "./discourse/templates/community-media-feedback";
import * as Mod30 from "./discourse/templates/community-media";
import * as Mod31 from "./discourse/templates/creator-community";
import * as Mod32 from "./discourse/templates/mod-community";
import * as Mod33 from "./lib/discourse-markdown/disable-indented-code";
import * as Mod34 from "./lib/discourse-markdown/html-details";
const compatModules = {
  "discourse/admin-community-navigation-plugin-route-map": Mod1,
  "discourse/community-navigation-route-map": Mod2,
  "discourse/components/community-game-order-handle": Mod3,
  "discourse/components/community-navigation-header-menu": Mod4,
  "discourse/components/community-secondary-navigation-item": Mod5,
  "discourse/components/community-secondary-navigation": Mod6,
  "discourse/components/community-topic-aggregation": Mod7,
  "discourse/controllers/admin-plugins/show/community-navigation-structure": Mod8,
  "discourse/initializers/community-navigation-admin-plugin-configuration-nav": Mod9,
  "discourse/initializers/community-navigation": Mod10,
  "discourse/initializers/disable-indented-code-block": Mod11,
  "discourse/lib/community-navigation-selection": Mod12,
  "discourse/lib/disable-indented-code-block": Mod13,
  "discourse/lib/disable-indented-code-rich-editor": Mod14,
  "discourse/pre-initializers/community-navigation-chat-default": Mod15,
  "discourse/routes/admin-plugins/show/community-navigation-structure": Mod16,
  "discourse/routes/community-creator-resources": Mod17,
  "discourse/routes/community-game": Mod18,
  "discourse/routes/community-media-feedback": Mod19,
  "discourse/routes/community-media": Mod20,
  "discourse/routes/creator-community": Mod21,
  "discourse/routes/mod-community": Mod22,
  "discourse/services/community-game-order": Mod23,
  "discourse/services/community-navigation-notices": Mod24,
  "discourse/services/community-navigation": Mod25,
  "discourse/services/erbox-toasts": Mod26,
  "discourse/templates/community-creator-resources": Mod27,
  "discourse/templates/community-game": Mod28,
  "discourse/templates/community-media-feedback": Mod29,
  "discourse/templates/community-media": Mod30,
  "discourse/templates/creator-community": Mod31,
  "discourse/templates/mod-community": Mod32,
  "lib/discourse-markdown/disable-indented-code": Mod33,
  "lib/discourse-markdown/html-details": Mod34,
};
export default compatModules;
